export const styles = {
  boxStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { md: "640px", sm: "75%", xs: "92%" },
    bgcolor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 24px 48px -12px rgba(15,23,42,0.25)",
    p: { xs: 2.5, sm: 3 },
    outline: "none",
    maxHeight: "92vh",
    overflowY: "auto",
  },
};
